/* ============================================
   NEONA Singles Early Access – Warenkorb-Leiste zur Gratisleuchte
   Rechnet bei jeder Warenkorbaenderung neu, wie viel bis zur Schwelle fehlt.
   Hook: 'cart:updated' am document (assets/theme.js). Easy Gift legt die
   Gratisleuchte selbst per /cart/add.js in den Warenkorb, ohne dieses Event;
   deshalb zusaetzlich: Positionen beobachten und /cart.js nachladen.
   Sichtbar ist die Leiste nur mit html.nn-ea, html.nn-sd-cora oder html.nn-sd-cosmo (siehe nn-header-timer-page).
   ============================================ */
(function () {
  'use strict';

  if (window.__nnEaCartGoal) return;
  window.__nnEaCartGoal = true;

  var TEXTS = {
    de: { left: 'Noch {amount} bis zu deiner Gratisleuchte', reached: 'Geschafft! Wähle jetzt deine Gratisleuchte.', done: 'Deine Gratisleuchte ist dabei.' },
    en: { left: '{amount} to go until your free lamp', reached: 'Done! Now choose your free lamp.', done: 'Your free lamp is in your cart.' },
    fr: { left: 'Plus que {amount} pour ta lampe offerte', reached: 'C’est gagné ! Choisis ta lampe offerte.', done: 'Ta lampe offerte est dans ton panier.' },
    it: { left: 'Mancano {amount} alla tua lampada in regalo', reached: 'Fatto! Ora scegli la tua lampada in regalo.', done: 'La tua lampada in regalo è nel carrello.' },
    nl: { left: 'Nog {amount} tot je gratis lamp', reached: 'Gelukt! Kies nu je gratis lamp.', done: 'Je gratis lamp zit in je winkelwagen.' },
    pl: { left: 'Jeszcze {amount} do darmowej lampy', reached: 'Gotowe! Wybierz teraz swoją darmową lampę.', done: 'Twoja darmowa lampa jest w koszyku.' },
    es: { left: 'Te faltan {amount} para tu lámpara gratis', reached: '¡Conseguido! Elige ahora tu lámpara gratis.', done: 'Tu lámpara gratis ya está en el carrito.' },
    sv: { left: 'Bara {amount} kvar till din gratislampa', reached: 'Klart! Välj nu din gratislampa.', done: 'Din gratislampa ligger i varukorgen.' }
  };

  /* Singles Day Sale (html.nn-sd-cora / html.nn-sd-cosmo): nur eine Gratisleuchte, nichts zu waehlen */
  var REACHED_SD = {
    de: 'Geschafft! Deine Gratis-{name} ist freigeschaltet.',
    en: 'Done! Your free {name} is unlocked.',
    fr: 'C’est gagné ! Ta {name} offerte est débloquée.',
    it: 'Fatto! La tua {name} in regalo è sbloccata.',
    nl: 'Gelukt! Je gratis {name} is vrijgespeeld.',
    pl: 'Gotowe! Twoja darmowa {name} jest odblokowana.',
    es: '¡Conseguido! Tu {name} gratis está desbloqueada.',
    sv: 'Klart! Din gratis {name} är upplåst.'
  };

  function sdName() {
    var c = document.documentElement.classList;
    if (c.contains('nn-sd-cosmo')) return 'COSMO';
    if (c.contains('nn-sd-cora')) return 'CORA';
    return '';
  }

  function root() { return document.querySelector('[data-nn-ea-goal]'); }

  function threshold(el, currency) {
    var map = {};
    try { map = JSON.parse(el.getAttribute('data-thresholds')) || {}; } catch (e) {}
    if (map[currency]) return map[currency];
    /* Andere Waehrungen: 250 € mit dem Shopify-Kurs umrechnen, auf volle Einheiten aufrunden */
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    var base = parseInt(el.getAttribute('data-base'), 10) || 25000;
    return Math.ceil((base * rate) / 100) * 100;
  }

  function money(cents, currency, locale) {
    var n = Math.ceil(cents / 100);
    var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (currency === 'CHF') return 'CHF ' + s;
    if (currency === 'PLN') return s + ' zł';
    if (currency === 'SEK') return s + ' kr';
    if (currency === 'EUR') return locale === 'nl' ? '€ ' + s : (locale === 'en' ? '€' + s : s + ' €');
    return s + ' ' + currency;
  }

  function hasGift(cart) {
    return (cart.items || []).some(function (it) {
      var p = it.properties || {};
      if (Object.prototype.hasOwnProperty.call(p, '_Gifted')) return true;
      return it.final_line_price === 0 && it.original_line_price > 0;
    });
  }

  function render(cart) {
    var el = root();
    if (!el || !cart) return;
    var locale = el.getAttribute('data-locale') || 'de';
    var t = TEXTS[locale] || TEXTS.en;
    var currency = cart.currency || el.getAttribute('data-currency') || 'EUR';
    /* Schweiz: keine Leiste (Lennart 03.11.2026) */
    var hidden = (el.getAttribute('data-hide') || '').split(',').indexOf(currency) > -1;
    el.classList.toggle('is-off', hidden);
    if (hidden) return;
    var goal = threshold(el, currency);
    var total = cart.total_price || 0;
    var gift = hasGift(cart);
    var text;
    if (gift) text = t.done;
    else if (total >= goal) text = sdName() ? (REACHED_SD[locale] || REACHED_SD.en).replace('{name}', sdName()) : t.reached;
    else text = t.left.replace('{amount}', '<em>' + money(goal - total, currency, locale) + '</em>');
    el.querySelector('[data-nn-ea-goal-text]').innerHTML = text;
    var pct = gift ? 100 : Math.max(0, Math.min(100, (total / goal) * 100));
    el.querySelector('[data-nn-ea-goal-fill]').style.width = pct + '%';
    el.classList.toggle('is-done', gift || total >= goal);
    el.classList.toggle('is-empty', !cart.item_count);
  }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 250);
  }

  function init() {
    var el = root();
    if (!el) return;
    /* Erster Stand aus Liquid, danach immer frisch aus /cart.js */
    render({
      currency: el.getAttribute('data-currency'),
      total_price: parseInt(el.getAttribute('data-total'), 10) || 0,
      item_count: 1,
      items: []
    });
    refresh();
    document.addEventListener('cart:updated', function (e) {
      if (e && e.detail && e.detail.cart) render(e.detail.cart);
      refresh();
    });
    var items = document.querySelector('[data-quick-cart] [data-items]');
    if (items && 'MutationObserver' in window) {
      new MutationObserver(refresh).observe(items, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
